module.exports = __webpack_public_path__ + "img/star_24px.5a19bf5a.svg";